module.exports = __webpack_public_path__ + "static/media/light-b-3.2fa6a05f.png";